define('vspot-angular/resources/organization-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        // AngularJS allows us to define multiple parameters in the same portion of the URL template.
        // As long as you only use one parameter at a time, AngularJS will construct the RESTful resource properly.
        // For params, if it is prefixed with @, then the value of that parameter is extracted from the data object
        // (useful for non-GET operations). In other words, if :controller is defined, :id should not, and vice versa.
        return $resource('/api/organizations/:id:controller',
            {
                controller: '@controller',
                id: '@id'
            },
            {
                /*
                 * Get a list of all the organizations that the current user is a member of.
                 */
                query: {
                    method: 'GET',
                    isArray: false
                },

                /*
                 * Get a single organization.
                 */
                get: {
                    method: 'GET'
                },

                /**
                 * Retrieve a list of users for the organization.
                 */
                showOrganizationalUsers: {
                    method: 'POST',
                    params: {
                        controller: 'show_organizational_users'
                    }
                },

                /**
                 * Delete users from an organization.
                 */
                deleteOrganizationalUsers: {
                    method: 'POST',
                    params: {
                        controller: 'delete_organizational_users'
                    }
                },

                /**
                 * Show all the activities that are members of shared groups within that organization.
                 */
                showOrganizationalActivities: {
                    method: 'POST',
                    params: {
                        controller: 'show_organizational_activities'
                    }
                },

                /**
                 * Copy an activity that is included within a group that is shared within an organization to the organization's owner.
                 */
                copyActivity: {
                    method: 'POST',
                    params: {
                        controller: 'copyactivity'
                    }
                },

                /**
                 * Show all volunteers in quick search
                 */
                 showAllMyVolunteers: {
                    method: 'POST',
                    params: {
                        controller: 'show_all_my_volunteers'
                    }
                },

                /**
                * Show volunteer job details in quick search
                */

                 showMyVolunteer: {
                    method: 'POST',
                    params: {
                        controller: 'show_my_volunteer'
                    }
                },

            }
        );
    }];
});

